export default __webpack_public_path__ + "static/media/02-manufacturing_preview.845f0837.jpg";